
import { computed, defineComponent, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { routeNames } from "@/router";
import AdminContractUserItem from "@/components/AdminContractUserItem.vue";
import AdminContractUserEdit from "@/components/AdminContractUserEdit.vue";

import store from "@/stores";
import { IUser } from "@/services/Models";

export default defineComponent({
  name: "AdminContractUsers",
  components: {
    AdminContractUserItem,
    AdminContractUserEdit,
  },
  setup() {
    const resource = store.useResource();
    const router = useRouter();
    const route = useRoute();
    const contractID = Number.parseInt(route.params.id as string);
    const contract = computed(() =>
      resource.data.contracts.find((x) => x.id == contractID)
    );
    // 新規ユーザ登録
    const toCreate = () =>
      router.push({
        name: routeNames.AdminContractUserCreate,
      });
    const users = computed(() => contract.value?.users);
    const editingModel = ref<IUser>();
    const isShowEdit = ref(false);
    const isDeleteMode = ref(false);
    // ユーザ編集画面表示
    const toEdit = (m: IUser) => {
      editingModel.value = m;
      isDeleteMode.value = false;
      isShowEdit.value = true;
    };
    // ユーザ削除画面表示
    const toDelete = (m: IUser) => {
      editingModel.value = m;
      isDeleteMode.value = true;
      isShowEdit.value = true;
    };
    // 削除
    const remove = async (m: IUser) => {
      if (!contract.value) return;
      const users = contract.value.users.filter((x) => x.id != m.id);
      await resource.saveContract({
        id: contract.value.id,
        companyName: contract.value.companyName,
        optionName: contract.value.optionName,
        plan: contract.value.plan,
        signed: contract.value.signed,
        expire: contract.value.expire,
        describe: contract.value.describe,
        users: users,
        status: contract.value.status,
        type: contract.value.type,
      });
    };
    // 適用
    const apply = async (m: IUser) => {
      if (!contract.value) return;
      const users = JSON.parse(JSON.stringify(contract.value.users)) as IUser[];
      const user = users.find((x) => x.id == m.id);
      if (!user) return;
      user.email = m.email;
      user.name = m.name;
      await resource.saveContract({
        id: contract.value.id,
        companyName: contract.value.companyName,
        optionName: contract.value.optionName,
        plan: contract.value.plan,
        signed: contract.value.signed,
        expire: contract.value.expire,
        describe: contract.value.describe,
        users: users,
        status: contract.value.status,
        type: contract.value.type,
      });
    };
    return {
      contract,
      users,
      toCreate,
      toEdit,
      toDelete,
      isDeleteMode,
      remove,
      isShowEdit,
      editingModel,
      apply,
    };
  },
});
